import { memo, useCallback } from 'react';
import { cn, Price } from '@divlab/divanui';

import Img from '@UI/Img';
import Link from '@UI/Link';
import capitalizeLine from '@Utils/capitalizeLine';
import styles from './SchemeCard.module.css';

import type { FC, HTMLAttributes, MouseEvent } from 'react';
import type { ConfiguratorOptionItemParameter } from '@Pages/PageProduct/typings';

export interface OptionCardProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  item: ConfiguratorOptionItemParameter;
  onClickItem?: (e: MouseEvent, item: ConfiguratorOptionItemParameter) => void;
}

const SchemeCard: FC<OptionCardProps> = (props) => {
  const { className, item, onClickItem, ...restProps } = props;

  const handleClickContainer = useCallback(
    (e: MouseEvent) => {
      if (item.calcDisabled || item.selected || item.disabled) return;
      if (onClickItem) onClickItem(e, item);
    },
    [item, onClickItem],
  );

  return (
    <div
      {...restProps}
      className={cn(
        styles.card,
        { [styles.selected]: item.selected, [styles.disabled]: item.calcDisabled },
        className,
      )}
    >
      <div className={styles.container} onClick={handleClickContainer}>
        <div className={styles.wrapperImage}>
          <Img className={styles.imageWrapper} cnImage={styles.image} src={item.image} />
        </div>

        <div className={styles.content}>
          <Link view='primary'>{capitalizeLine(item.title)}</Link>

          {!!item.price.actual && (
            <div className={styles.price}>
              +
              <Price price={item.price.actual} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default memo(SchemeCard);
